import Vue from "vue";
import spinner from "./Spinner";

let spinnerList = new WeakMap();
let tempSpinner = [];
export default {
  name: "Spinner",
  async showLoading(
    target,
    showBg = true,
    picSpinner = false,
    immediate = false
  ) {
    target = target ? target : document.getElementsByTagName("body")[0];
    // console.log("target", target, spinnerList.has(target), spinnerList);
    try {
      let classname = "spinner" + Date.now(),
        myTarget = null;
      if (!spinnerList.has(target)) {
        // 如果当前target没有创建过spinner
        let mySpinner = new Vue({
          render: (h) =>
            h(spinner, {
              props: {
                showBg,
                picSpinner,
              },
              class: classname,
            }),
        });
        let temp = mySpinner.$mount();
        myTarget =
          target.hasOwnProperty("_isVue") && target._isVue
            ? target.$el
            : Array.isArray(target)
            ? target[0]
            : target; // 兼容组件标签和原生标签
        myTarget.appendChild(temp.$el);
        tempSpinner.push(target);
        spinnerList.set(target, mySpinner);
      }
      spinnerList.get(target).$children[0].show(immediate); // 显示
    } catch (err) {
      console.log(err);
    }
  },
  hideLoading(target) {
    target = target ? target : document.getElementsByTagName("body")[0];
    if (spinnerList.has(target)) {
      spinnerList.get(target).$children[0].hide(); // 隐藏
      spinnerList.delete(target);
    } else {
      this.clearSpinnerList();
    }
  },
  clearSpinnerList() {
    for (let k of tempSpinner) {
      if (spinnerList.get(k)) {
        spinnerList.get(k).$children[0].hide();
        spinnerList.delete(k);
        document.querySelectorAll(".spinner-box").forEach((i) => i.remove());
      }
    }
  },
};
